module.exports = {
  "CS_FE_Select_Product_VbhT": "Selecciona “Rol de PM y desarrollador”.",
  "CS_status_Dibi_hJVY": "Continuar ({{time_second}})",
  "CS_system_Submission_cEep": "Enviar",
  "CS_1_WiFi_pyYD": "Wi-Fi",
  "CS_FE_You_can_yIrn": "Por favor, selecciona el tipo de permiso que necesitas y luego haz clic en “Solicitar”.",
  "CS_status_SYOk_iYUs": "B2B",
  "CS_status_ZoGi_sjyC": "Centro de conductores",
  "CS_1_Environment_Bitb": "Entorno",
  "CS_1_View_Current_IOCz": "Ver permisos actuales",
  "CS_optimazation__CALn": "Tu estado se cambió automáticamente a desconectado debido a la inactividad. Actualiza la página.",
  "CS_1_Upgrade_current_dlbi": "Aumentar permisos actuales",
  "CS_optimazation_You_have_PlRk": "Has estado inactivo en {{workbench_name}} durante {{time_duration}} minuto(s). ¿Quieres seguir trabajando en {{workbench_name}}?",
  "CS_optimazation__akmu": "Desconectado",
  "CS_status_ixVR_bjQc": "Ventas",
  "CS_feedback_Feedback_bGXI": "Comentarios",
  "CS_optimazation__ZkZb": "Mantente {{work_status}}",
  "CS_System_ZQjn_eCbz": "Tipo de habilidad capacitada anteriormente",
  "CS_status_CjDQ_uaVo": "Antifraude",
  "CS_Status_In_the_PrHj": "Otras pausas en curso",
  "CS_1_Thank_you_WUlL": "¡Gracias por tus comentarios!",
  "CS_status_ErSl_RYFT": "Llamar",
  "CS_1_Log_in_sMmF": "Cerrar sesión",
  "CS_status_HxNd_EpND": "Cámara de seguridad",
  "CS_status_HMDn_eBqC": "Participación",
  "CS_status_zoxI_Nral": "El tipo de servicio actual es {{service_type}}",
  "CS_feedback_1_Please_IBbL": "1. Por favor, dinos cuál fue la función con la que tuviste un problema y describe la situación.",
  "CS_1_Closing_Online_tykf": "Desactivar el chat en vivo",
  "CS_1_Open_automatic_PZyZ": "Activar la asignación automática de tickets",
  "CS_FE_Ark_Visitor_pMCT": "Permiso para visualizar CRM",
  "CS_1_Enter_text_NYGo": "Escriba su comentario aquí",
  "CS_status_WEAx_MWhv": "Seguridad",
  "CS_System_lIGK_Ukwr": "Tipo de habilidad actual",
  "CS_optimazation_Telephone_workstations_TBZP": "Mesa de trabajo para llamadas",
  "CS_system_Name_of_QEFT": "Nombre del puesto",
  "CS_status_dweh_wRWT": "Revisión de inducción",
  "CS_optimazation__work_JhhB": "Has estado {{work_status}} durante más de {{time_duration}} minutos. ¿Quieres permanecer {{work_status}}?",
  "CS_Workbench_Online_Customer_yXxN": "Mesa de trabajo del chat en vivo",
  "CS_status_wfIq_oGhU": "Redes sociales",
  "CS_optimazation_Time_out_sqTe": "Recordatorio de tiempo de espera",
  "CS_1_Country_ilYw": "País",
  "CS_1_Closed_automatic_jUvk": "Desactivar la asignación automática de tickets",
  "CS_1_System_Category_rAJC": "Categoría de negocio",
  "CS_status_aobY_gRor": "Has estado {{status_name}} durante más de {{hour_time}} hora(s). ¿Quieres permanecer {{status_name}}?",
  "CS_FE_If_you_lCHy": "Si estás en el equipo de producto y desarrollo de servicio al cliente:",
  "CS_status_qORz_iUKj": "Colecciones",
  "CS_optimazation_The_status_hqOj": "No se puede cambiar el estado. Inicia sesión en Genesys.",
  "CS_optimazation_After_the_dZsk": "Procesamiento posterior a la llamada",
  "CS_feedback_Please_upload_zHqW": "2. Carga la imagen completa que nos ayude a identificar el problema.",
  "CS_system_Sectoral_information_JizK": "Información del departamento",
  "CS_optimazation__zXnN": "Tiempo de espera de {{work_status}}",
  "CS_status_eJtD_Xawt": "Soporte tecnológico",
  "CS_1_Personal_settings_eXQD": "Configuración personal",
  "CS_optimazation_Asynchronous_workstations_JwBF": "Mesa de trabajo para mensajes escritos",
  "CS_status_YyJG_Khkr": "Primera línea de Soporte DiDi",
  "CS_FE_Product_R_RxVt": "Rol de PM y desarrollador",
  "CS_1_Online_Customer_SvgB": "El chat en vivo está activado.",
  "CS_status_pySZ_YnQN": "Revisión de contenidos",
  "CS_1_Open_Online_umkV": "Activar el chat en vivo",
  "CS_1_Languages_hMbf": "Idioma",
  "CS_system_Immediate_superior_VDep": "Supervisor",
  "CS_1_Personal_settings_uOXW": "Configuración personal",
  "CS_FE_Choose_Ark_VJpl": "Selecciona “Permiso para visualizar CRM” (número de identificación del rol: 14211591).",
  "CS_1_Permissions_MuvF": "Permisos",
  "CS_FE_If_you_WAuP": "Si tienes un rol diferente (formas parte de producto y desarrollo de IBT, operaciones o te encuentras en China):",
  "CS_status_ocdu_QQQW": "Videollamada",
  "CS_1_Automatic_Order_Mnnv": "La asignación automática de tickets está activada.",
  "CS_optimazation_Make_sure_FVAQ": "¿Estás seguro de que deseas cambiar el estado de {{workbench_name}} de {{status_one}} a {{status_two}}? Una vez que lo cambies, el estado de las otras mesas de trabajo se establecerá en {{status_three}}.",
  "CS_1_Comments_RcMN": "Enviar",
  "CS_1_Notification_uJTM": "Notificaciones",
  "status_400": "Comiendo...",
  "refreshPage": "Actualizar la página",
  "countDownBegin": "Operation after ",
  "infoChange": "La categoría del sistema se ha cambiado en otra página. El sistema no podrá guardar sus cambios. Actualice la página.",
  "view": "Ver",
  "online": "Entorno online",
  "message": "Mensajes",
  "changeStatusV1": "¿Estás seguro(a) de que quieres cambiar tu estado de ",
  "changeStatusV2": " a ",
  "changeStatusV3": "？",
  "time": "Fecha",
  "continue": "Continuar",
  "knowledge": "Base de datos",
  "status_500": "Descansando...",
  "artificial": "Mensaje directo",
  "countDownEnd": "S",
  "clickStartWorking": "Para asegurar la precisión de los datos, pulsa “Comenzar” antes de usar el sistema.",
  "statusChange": "Para aceptar tickets automáticamente, tu estado debe estar como “Disponible”.",
  "CS_Workbench_There_are_wmir": "No se puede cambiar el estado de trabajo. Por favor, concluye primero todos los chats en vivo que están en curso.",
  "type": "Tipo de mensaje",
  "status_200": "Capacitación en curso...",
  "cancel": "Cancelar",
  "logout": "Salir",
  "sendTo": "Para",
  "satisfaction_content": "Tienes una encuesta para responder y debe tomarte unos 5 minutos. Si desea responder ahora, haga clic en el link a continuación o presione el botón \"Continuar\".",
  "CS_Workbench_Open_the_lnHa": "开启在线客服功能，需要将工作状态切换为“工作中”。",
  "ticketNumber": " ticket(s) pendiente(s)",
  "more": "More",
  "satisfaction_title": "Tienes una encuesta",
  "pre": "Ambiente previo al evento",
  "customerService": "Centro de llamadas",
  "status_300": "Reunión en curso...",
  "sendFrom": "De",
  "youhave": "Tienes ",
  "startWorking": "Comenzar",
  "small": "Ambiente de aceptación",
  "offWorkV": "¿Estás seguro(a) de que quieres desconectarte? Esto marcará el cierre de tu día.",
  "read": "Have read",
  "Settings": "Configuración",
  "welcomeCS": "¡Bienvenido(a) al sistema de servicio al cliente de DiDi Global!",
  "cs-micro-front-end---more": "",
  "cs-micro-front-end---welcomeCS": "",
  "cs-micro-front-end---clickStartWorking": "",
  "cs-micro-front-end---startWorking": "",
  "cs-micro-front-end---status_200": "",
  "cs-micro-front-end---status_300": "",
  "cs-micro-front-end---status_400": "",
  "cs-micro-front-end---status_500": "",
  "cs-micro-front-end---offWorkV": "",
  "cs-micro-front-end---changeStatusV1": "",
  "cs-micro-front-end---changeStatusV2": "",
  "cs-micro-front-end---changeStatusV3": "",
  "cs-micro-front-end---cancel": "",
  "cs-micro-front-end---continue": "",
  "cs-micro-front-end---logout": "",
  "cs-micro-front-end---online": "",
  "cs-micro-front-end---pre": "",
  "cs-micro-front-end---small": "",
  "cs-micro-front-end---statusChange": "",
  "cs-micro-front-end---youhave": "",
  "cs-micro-front-end---ticketNumber": "",
  "cs-micro-front-end---view": "",
  "cs-micro-front-end---Settings": "",
  "cs-micro-front-end---infoChange": "",
  "cs-micro-front-end---refreshPage": "",
  "cs-micro-front-end---satisfaction_title": "",
  "cs-micro-front-end---satisfaction_content": "",
  "cs-micro-front-end---knowledge": "",
  "cs-micro-front-end---customerService": "",
  "cs-micro-front-end---artificial": "",
  "cs-micro-front-end---sendFrom": "",
  "cs-micro-front-end---sendTo": "",
  "cs-micro-front-end---type": "",
  "cs-micro-front-end---time": "",
  "cs-micro-front-end---read": "",
  "cs-micro-front-end---countDownBegin": "",
  "cs-micro-front-end---countDownEnd": "",
  "cs-micro-front-end---CS_Workbench_There_are_wmir": "",
  "cs-micro-front-end---CS_Workbench_Open_the_lnHa": "",
  "cs-micro-front-end---message": "",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Sorry_permissions_nBRG": "Sorry, you don’t have permission to access the system. To request permission, please follow the instructions below.",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_oPui": "If you’re not a Customer Service Representative:",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Production_and_mGLI": "Select the permission type you need below, then click Apply.\n\nIf you’re on the customer service product and development team: Select the ‘PM and DEV Role‘\n\nFor other roles (IBT product and development, operations, or domestic staff): Select the ‘CRM View Permission (Role ID: 14211591)’",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_See_permissions_OzjQ": "For more information, please refer to the Customer Service System Access Guidelines",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Permission_Kapv": "Select your access permission",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_vLUC": "If you’re a Customer Service Representative:",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Hello_permissions_SDxI": "Please contact your supervisor or local admin responsible for customer service permissions for assistance."
}